/**
 * Get an item at the given index, but use undefined in the type.
 * @param items The items to get an item from.
 * @param index The index of the item.
 * @returns The item at the given index.
 */
export function GetIndex<T>(items: readonly T[], index: number): T | undefined {
  return items[index]
}
